import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useT } from "@/i18n";

const SEO = {
  "/": {
    pt: {
      title: "Yin Motion — Saúde e Bem-Estar em Tavira | Fisioterapia, Pilates Clínico e mais",
      description:
        "Clínica de fisioterapia e bem-estar em Tavira. Fisioterapia, Pilates Clínico, Gyrotonic®, Power Plate, Osteopatia, Psicologia e Medicina Chinesa. Marque a sua consulta.",
    },
    en: {
      title: "Yin Motion — Health & Wellness in Tavira | Physiotherapy, Clinical Pilates and more",
      description:
        "Physiotherapy and wellness clinic in Tavira, Portugal. Physiotherapy, Clinical Pilates, Gyrotonic®, Power Plate, Osteopathy, Psychology and Chinese Medicine. Book your appointment.",
    },
  },
  "/fisioterapia": {
    pt: {
      title: "Fisioterapia em Tavira | Yin Motion",
      description:
        "Fisioterapia personalizada em Tavira com avaliação completa, tecnologia avançada (tecarterapia, ondas de choque, EPI) e acompanhamento individual. Marque a sua avaliação.",
    },
    en: {
      title: "Physiotherapy in Tavira | Yin Motion",
      description:
        "Personalised physiotherapy in Tavira with full assessment, advanced technology (tecar therapy, shockwave, EPI) and one-to-one care. Book your assessment.",
    },
  },
  "/pilates-clinico": {
    pt: {
      title: "Pilates Clínico em Tavira | Yin Motion",
      description:
        "Pilates Clínico com acompanhamento especializado em Tavira. Equipamentos Reformer, Cadillac, Barrel e mais. Fortaleça o corpo com segurança e precisão.",
    },
    en: {
      title: "Clinical Pilates in Tavira | Yin Motion",
      description:
        "Clinical Pilates with specialist guidance in Tavira. Reformer, Cadillac, Barrel and more. Strengthen your body safely and precisely.",
    },
  },
  "/gyrotonic": {
    pt: {
      title: "Gyrotonic® em Tavira | Yin Motion",
      description:
        "Gyrotonic® em Tavira — movimento tridimensional que melhora a mobilidade, a postura e a força de forma fluida e segura. Sessões individualizadas.",
    },
    en: {
      title: "Gyrotonic® in Tavira | Yin Motion",
      description:
        "Gyrotonic® in Tavira — three-dimensional movement that improves mobility, posture and strength in a fluid, safe way. Individual sessions.",
    },
  },
  "/power-plate": {
    pt: {
      title: "Power Plate em Tavira | Yin Motion",
      description:
        "Treino com Power Plate em Tavira — estimulação neuromuscular com tecnologia avançada para força, recuperação e circulação. Sessões acompanhadas.",
    },
    en: {
      title: "Power Plate in Tavira | Yin Motion",
      description:
        "Power Plate training in Tavira — neuromuscular stimulation with advanced technology for strength, recovery and circulation. Guided sessions.",
    },
  },
  "/treino-clinico": {
    pt: {
      title: "Treino Clínico Personalizado em Tavira | Yin Motion",
      description:
        "Treino clínico personalizado em Tavira, desenhado por fisioterapeutas para os seus objetivos: reabilitação, prevenção de lesões e condição física.",
    },
    en: {
      title: "Personalised Clinical Training in Tavira | Yin Motion",
      description:
        "Personalised clinical training in Tavira, designed by physiotherapists for your goals: rehabilitation, injury prevention and fitness.",
    },
  },
  "/osteopatia": {
    pt: {
      title: "Osteopatia em Tavira | Yin Motion",
      description:
        "Osteopatia em Tavira — abordagem manual global para dores, tensões e disfunções, com avaliação individual e tratamento personalizado.",
    },
    en: {
      title: "Osteopathy in Tavira | Yin Motion",
      description:
        "Osteopathy in Tavira — a whole-body manual approach for pain, tension and dysfunction, with individual assessment and personalised treatment.",
    },
  },
  "/psicologia": {
    pt: {
      title: "Psicologia em Tavira | Yin Motion",
      description:
        "Apoio psicológico em Tavira — acompanhamento profissional e confidencial para ansiedade, stress, gestão emocional e desenvolvimento pessoal.",
    },
    en: {
      title: "Psychology in Tavira | Yin Motion",
      description:
        "Psychological support in Tavira — professional, confidential care for anxiety, stress, emotional wellbeing and personal development.",
    },
  },
  "/medicina-chinesa": {
    pt: {
      title: "Medicina Tradicional Chinesa em Tavira | Yin Motion",
      description:
        "Medicina Tradicional Chinesa em Tavira — acupuntura e técnicas complementares para equilíbrio, alívio da dor e bem-estar global.",
    },
    en: {
      title: "Traditional Chinese Medicine in Tavira | Yin Motion",
      description:
        "Traditional Chinese Medicine in Tavira — acupuncture and complementary techniques for balance, pain relief and overall wellbeing.",
    },
  },
  "/terapia-fala": {
    pt: {
      title: "Terapia da Fala em Tavira | Yin Motion",
      description:
        "Terapia da Fala em Tavira para crianças e adultos — comunicação, linguagem, fala e deglutição, com avaliação e intervenção personalizadas.",
    },
    en: {
      title: "Speech Therapy in Tavira | Yin Motion",
      description:
        "Speech and language therapy in Tavira for children and adults — communication, language, speech and swallowing, with personalised assessment.",
    },
  },
};

export const Seo = () => {
  const { pathname } = useLocation();
  const { lang } = useT();

  useEffect(() => {
    const entry = SEO[pathname] || SEO["/"];
    const { title, description } = entry[lang] || entry.pt;
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
  }, [pathname, lang]);

  return null;
};
